import { cx } from '@/lib/utils'
import { forwardRef } from 'react'

type Props =
    | ({
          as?: 'input'
          type?: string
          inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
      } & BaseProps &
          React.InputHTMLAttributes<HTMLInputElement>)
    | ({
          as: 'textarea'
      } & BaseProps &
          React.TextareaHTMLAttributes<HTMLTextAreaElement>)

type BaseProps = {
    placeholder: string
    ariaLabel: string
    error?: string
}

const Field = forwardRef<HTMLInputElement | HTMLTextAreaElement, Props>(function Field(props, ref) {
    const { placeholder, ariaLabel, error, as, className, ...rest } = props as Props & { className?: string }

    const base =
        'w-full rounded-lg bg-white px-4 py-3 text-sm text-text shadow-sm placeholder:text-muted ' +
        'transition-[box-shadow,transform] duration-200 focus:shadow-md'

    if (as === 'textarea') {
        return (
            <div>
                <textarea
                    ref={ref as never}
                    aria-label={ariaLabel}
                    placeholder={placeholder}
                    className={cx(base, 'resize-none', className)}
                    {...(rest as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
                />
                {error ? <p className='mt-2 text-xs text-muted'>{error}</p> : null}
            </div>
        )
    }

    return (
        <div>
            <input
                ref={ref as never}
                aria-label={ariaLabel}
                placeholder={placeholder}
                className={cx(base, className)}
                {...(rest as React.InputHTMLAttributes<HTMLInputElement>)}
            />
            {error ? <p className='mt-2 text-xs text-muted'>{error}</p> : null}
        </div>
    )
})

export default Field
